import api from "./api";

const AppParamAPI = {
    getAll: () => api.get(`/application-params/all`),
    getById: (id) => api.get(`/application-params/details/${id}`),
    update: (data) => api.post(`/application-params/update`, data),
};

export default AppParamAPI;